import { type ParsedUrlQuery } from 'node:querystring';

import { QueryParamNames } from '~/constants/search';

export const getSkipOnboardingEnabledFromQuery = (query: ParsedUrlQuery): boolean => {
  return query[QueryParamNames.skipOnboarding] === 'true';
};
